import PropTypes from 'prop-types';
import React from 'react';
import { Alert } from 'reactstrap';

const Errors = ({ code, defaultValue, errors, title, defaultTitle, ...props }) => {
  if (!code) {
    return null;
  }

  const error = errors[code];
  const isErrorValid = error && (error.value || error.title);

  return (
    <Alert color="danger" {...props}>
      {isErrorValid ? (
        <React.Fragment>
          {error.title && <strong>{error.title}</strong>}
          {error.value && <p>{error.value}</p>}
        </React.Fragment>
      ) : (
        <React.Fragment>
          {defaultTitle && <strong>{defaultTitle}</strong>}
          <p>{errors[code] || defaultValue}</p>
        </React.Fragment>
      )}
    </Alert>
  );
};

Errors.defaultProps = {
  code: null,
  defaultValue: null,
  defaultTitle: null,
  title: null
};

Errors.propTypes = {
  code: PropTypes.string,
  defaultValue: PropTypes.string,
  errors: PropTypes.object.isRequired,
  title: PropTypes.string,
  defaultTitle: PropTypes.string
};

export default Errors;

